var map = {
	"./pages/detail": [
		"67eb",
		"chunk-25db4572"
	],
	"./shared/detail": [
		"97cd",
		"chunk-d359cd7c",
		"chunk-eb29a9c4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a5a2";
module.exports = webpackAsyncContext;